export default {
    listagem: {
        titulo_pagina: 'Lista de Credenciales',
        novo: 'Crear Nueva Credencial',
        table: {
            empty: 'No se encontraron credenciales',
            nome: 'Nombre',
            empresa: 'Empresa',
            usuario: 'Usuario',
            homologacao: 'Homologación',
            classe: 'Clase',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Credencial',
            editar: 'Editar Credencial'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre de la credencial'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa a la que pertenece la credencial'
            },
            usuario: {
                label: 'Nombre de Usuario',
                description: 'Nombre que se utilizará en la credencial'
            },
            senha: {
                label: 'Contraseña',
                description: 'Contraseña que se utilizará en la credencial'
            },
            entidade: {
                label: 'Entidad',
                description: 'Entidad que se utilizará en la credencial'
            },
            homologacao: {
                label: 'Homologación',
                description: 'Estado activo o inactivo de la credencial en Homologación'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo de la credencial'
            },
            botao_salvar : 'Guardar Credencial'
        },
        create: {
            success: '¡Credencial creada con éxito!',
            error: '¡Error al crear la Credencial!'
        },
        update: {
            success: '¡Credencial editada con éxito!',
            error: '¡Error al editar la credencial!'
        }
    }
}
